import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { FormattedMessage, injectIntl } from 'react-intl';
import { RuSecondaryButton, Warning } from '@silverrailtech/srtlibrary';
import inlineStyles from './styles';
import messages from './messages';
import ExtendedSnackbar from '../../../../components/ExtendedSnackbar/ExtendedSnackbar';
import RefreshIndicator from '../../../../components/RefreshIndicator/RefreshIndicator';

import { StyledOption, StyledParagraph } from './AmendBookingStyled';

const StyledDialog = styled(Dialog)(() => ({
	'& .MuiPaper-root': {
		...inlineStyles.dialogPaper,
	},
}));

const getErrorMessage = (amend, exchange) => {
	if (!amend && !exchange) {
		return messages.lblExchangeAmendBookingNotAvailable;
	}
	if (!amend) {
		return messages.lblAmendBookingNotAvailable;
	}
	if (!exchange) {
		return messages.lblExchangeBookingNotAvailable;
	}
	return null;
};

const AmendBookingDialog = ({
	open,
	amendmentsData,
	isFetching,
	errorText,
	setErrorText,
	handleClose,
	onExchangeClick,
	onAmendClick,
	isExchangeAvailable,
}) => {
	const isAmendAvailable =
		amendmentsData?.BookingOrderSeatReservationAmendmentInfo
			?.BookingOrderSeatReservationAmendmentIsAvailable;
	const errorMessage = getErrorMessage(isAmendAvailable, isExchangeAvailable);

	return (
		<>
			<StyledDialog
				open={open}
				onClose={() => {
					handleClose();
				}}
				disableEnforceFocus
				maxWidth={false}
			>
				<DialogTitle>
					<FormattedMessage {...messages.lblBookingDialogTitle} />
				</DialogTitle>
				<DialogContent style={{ minHeight: '120px' }}>
					<RefreshIndicator
						size={36}
						top="50%"
						left="45%"
						status={isFetching ? 'loading' : 'hide'}
					/>
					{errorMessage && !isFetching && (
						<Warning
							text={<FormattedMessage {...errorMessage} />}
							variant="important"
						/>
					)}
					{isAmendAvailable && (
						<StyledOption>
							<StyledParagraph>
								<FormattedMessage {...messages.lblAmendBooking} />
							</StyledParagraph>
							<RuSecondaryButton
								color="neutral_1"
								onClick={onAmendClick}
								style={{ width: '200px' }}
							>
								<FormattedMessage {...messages.btnAmendOrder} />
							</RuSecondaryButton>
						</StyledOption>
					)}
					{isExchangeAvailable && (
						<StyledOption>
							<StyledParagraph>
								<FormattedMessage {...messages.lblExchangeBooking} />
							</StyledParagraph>
							<RuSecondaryButton
								color="neutral_1"
								onClick={onExchangeClick}
								style={{ width: '200px' }}
							>
								<FormattedMessage {...messages.btnExchangeOrder} />
							</RuSecondaryButton>
						</StyledOption>
					)}
				</DialogContent>
			</StyledDialog>
			<ExtendedSnackbar
				id="srtAmendBookingSnackBar"
				open={errorText !== ''}
				message={errorText}
				onClose={() => setErrorText('')}
			/>
		</>
	);
};

AmendBookingDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	amendmentsData: PropTypes.object.isRequired,
	isFetching: PropTypes.bool.isRequired,
	errorText: PropTypes.string.isRequired,
	setErrorText: PropTypes.func.isRequired,
	handleClose: PropTypes.func.isRequired,
	onExchangeClick: PropTypes.func.isRequired,
	onAmendClick: PropTypes.func.isRequired,
	isExchangeAvailable: PropTypes.bool,
};

export default injectIntl(AmendBookingDialog);
